// import Konva from 'konva'

export default {
  methods: {
    createGroups (shape) {
      this.canDelete = true
      this.focusedElement = shape.attrs.id
      this.highlightShape = shape
      this.highlightSelection(shape)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/groupShapes.js